/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import './../app.scss';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Cookie from './cookie';

// Logos
import ZMGLogo from '../images/logos/zmg.svg';
import BDZVLogo from '../images/logos/bdzv.svg';

const isPartiallyActive = ({ isPartiallyCurrent }) =>
  isPartiallyCurrent ? { className: 'small text-primary' } : { className: 'small' };

const Layout = ({ children, resetCookies }) => (
  <Fragment>
    <Cookie resetCookies={resetCookies}/>
    <main>{children}</main>
    <footer>
      <div className="container-md d-flex justify-content-between align-items-center">
        <ul className="footer-links list-inline w-100 m-0">
          <li className="list-inline-item">
            <Link to="/presentation" getProps={isPartiallyActive}>
              E-Paper-Qualitäten
            </Link>
          </li>
          <li className="list-inline-item">
            <Link to="/contact" activeClassName="text-primary" className="small">
              Kontakt
            </Link>
          </li>
          <li className="list-inline-item">
            <Link to="/imprint" activeClassName="text-primary" className="small">
              Impressum
            </Link>
          </li>
          <li className="list-inline-item">
            <Link to="/data-privacy" activeClassName="text-primary" className="small">
              Datenschutzerklärung
            </Link>
          </li>
        </ul>
        <div className="footer-logos d-flex align-items-center">
          <a href="https://www.bdzv.de" rel="noopener noreferrer" target="_blank" className="bdzv">
            <BDZVLogo />
          </a>
          <a href="https://www.zmg.de" rel="noopener noreferrer" target="_blank" className="zmg">
            <ZMGLogo />
          </a>
        </div>
      </div>
    </footer>
  </Fragment>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
